import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class StrategyRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    allStrategies() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/strategies`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/strategies`, {headers: headers});
    }

    allStrategiesOfUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/strategies/user/${store.state.user.id}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    allStrategiesOfExternalUser(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/strategies/user/${userId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    findStrategiesOfClub(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/strategies/club/${clubId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/ext/strategies/club/${clubId}`, {headers: headers});
    }

    createStrategy(strategy) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/strategies`, strategy, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.post(`${this.basePath}/strategies`, strategy, {headers: headers});
    }

    addStrategy(strategyId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/strategies/add?userId=${store.state.user.id}&strategyId=${strategyId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/ext/strategies/add?userId=${store.state.user.id}&strategyId=${strategyId}`, {headers: headers});
    }

    deleteStrategyToUser(strategyId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/strategies?userId=${store.state.user.id}&strategyId=${strategyId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.delete(`${this.basePath}/ext/strategies?userId=${store.state.user.id}&strategyId=${strategyId}`, {headers: headers});
    }
}

export default new StrategyRepository();
